<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQConcerti',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Concerti", link : 'conv-bitq-concerti' } ],

        // Nome welfarebit del servizio
        service_title : "Concerti",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 19
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>